export const PROD_ENDPOINT = "api.clava-sports.com";
export const DEV_ENDPOINT = "api.dev.stockner-heutrocknung.it";
export const SELECTED_DRYING_UNIT_KEY = "selected-drying-unit";

export const MINUTE_MS = 60_000;
export const HOUR_MS = 3_600_000;
export const DAYS_MS = HOUR_MS * 24;
